// @flow

import { getUnsavedWorkMessage, willLoseUnsavedWork } from '../utils/unsavedwork'

export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

export function showModal (modalType: string, modalProps: Object) : Object {
  return {
    type: SHOW_MODAL,
    modalType: modalType,
    modalProps: modalProps
  }
}

export function hideModal () : Function {
  return (dispatch, getState) => {
    const unsavedWork = getState().unsavedwork.items
    if (
      !willLoseUnsavedWork({ unsavedWork, isModalClose: true }) ||
      window.confirm(getUnsavedWorkMessage(true))
    ) {
      dispatch(forceHideModal())
    }
  }
}

export function forceHideModal () : Object {
  return {
    type: HIDE_MODAL
  }
}
